var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUseAltitude = function SvgUseAltitude(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.25 8.342V3.796l-1.85 1.84-1.044-1.044L19 .948l3.644 3.644-1.044 1.07-1.85-1.85v4.53zM1.952 17.43l5.096-6.808 3.98 5.308h8.02l-5-6.65-2.75 3.646-.942-1.246 3.692-4.923 8 10.673z"
  })));
};
export default SvgUseAltitude;